import type { Text } from 'mdast';
import { trimLines } from 'trim-lines';

import type { State } from '../state';

/** Turn an mdast `text` node into pm text. */
export function text(state: State, node: Text): void {
	state.addText(trimLines(String(node.value)));
}
